<template>
  <div
    :class="['application', isDark ? 'black_bg' : 'white_bg']"
    v-if="applicationFeedback"
  >
    <div class="application_contain">
      <div class="application-nav">
        <img
          v-if="isDark"
          src="../assets/back_black.png"
          alt=""
          @click="back"
        />
        <img v-else src="../assets/back.png" alt="" @click="back" />
      </div>
      <div :class="[isDark ? 'contain-title_black' : 'contain-title']">
        <p>{{ applicationFeedback.title }}</p>
      </div>
      <van-radio-group
        class="contain-radioGroup"
        v-model="checked"
        @change="radioGroupChange"
      >
        <!-- 以下几种语言需要反向显示 -->
        <template
          v-if="['ar_EG', 'iw_IL', 'fa_IR', 'ur_PK'].indexOf(langKey) > -1"
        >
          <van-radio
            :name="index"
            :class="[
              'contain-field',
              isDark ? 'contain-field_black' : 'contain-field_white',
            ]"
            v-for="(item, index) in applicationFeedback.feedBackCates"
            :key="index"
          >
            {{ item.txt }}
            <template #icon="">
              <img
                class="img-icon"
                :src="+checked === index ? img_checked : img_unchecked"
              />
            </template>
          </van-radio>
        </template>
        <van-radio
          v-else
          label-position="left"
          :name="index"
          :class="[
            'contain-field',
            isDark ? 'contain-field_black' : 'contain-field_white',
          ]"
          v-for="(item, index) in applicationFeedback.feedBackCates"
          :key="index"
        >
          {{ item.txt }}
          <template #icon="">
            <img
              :class="`img-icon`"
              :src="+checked === +index ? img_checked : img_unchecked"
            />
          </template>
        </van-radio>
      </van-radio-group>
      <div :class="['contain-field_option']">
        <van-field
          v-if="+checked === otherIndex"
          ref="otherOpinionRef"
          :class="[
            'textarea',
            isDark ? 'contain-field_black' : 'contain-field_white',
            isDark ? 'black_bg' : 'white_bg',
          ]"
          v-model="opinion"
          rows="3"
          autosize
          autofocus
          label=""
          type="textarea"
          placeholder="Please enter option"
        />
      </div>
    </div>
    <div class="application_footer">
      <van-button
        class="application_btn"
        type="primary"
        size="large"
        color="#1989fa"
        :square="true"
        @click="submit"
        >{{ applicationFeedback.submitTxt }}
      </van-button>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { feedBack } from "../config/feedBack";
import { gtag, gtagApp, parseQueryString } from "../utils/util";
import {
  RadioGroup,
  Radio,
  Cell,
  CellGroup,
  Button,
  Field,
  Toast,
  Icon,
} from "vant";

Vue.use(RadioGroup);
Vue.use(Radio);
Vue.use(Cell);
Vue.use(CellGroup);
Vue.use(Button);
Vue.use(Field);
Vue.use(Toast);
Vue.use(Icon);

for (const key in feedBack) {
  if (Object.hasOwnProperty.call(feedBack, key)) {
    const element = feedBack[key];
    element.feedBackCates = element.feedBackCates.map((item) => {
      return {
        txt: item,
        isChecked: false,
      };
    });
  }
}
export default {
  name: "Application",
  data() {
    // const img_checked = require("../assets/checked.png");
    // const img_unchecked = require("../assets/unChecked.png");
    return {
      applicationFeedback: null,
      checked: -1,
      opinion: "",
      langKey: "",
      img_checked: require("../assets/checked.png"),
      img_checked_black: require("../assets/checked_black.png"),
      img_unchecked: require("../assets/unChecked.png"),
      isDark: 0, // 0是白天 1暗黑模式
    };
  },
  mounted() {
    this.getLang();
  },
  computed: {
    otherIndex() {
      return (
        this.applicationFeedback &&
        this.applicationFeedback.feedBackCates.length - 1
      );
    },
  },
  methods: {
    getLang() {
      // const params = parseQueryString(location.href) || {};
      const params = parseQueryString(location.search) || {}; // fix
      const defaultLocale = params.defaultLocale
        ? params.defaultLocale.toUpperCase()
        : "";
      if (params.lang) {
        // 先匹配语言，语言匹配出多条数据再匹配国家如果都没有使用英语
        const keys = Object.keys(feedBack) || [];
        const filterLang = keys.filter((key) => {
          return key.split("_")[0].toUpperCase() === params.lang.toUpperCase();
        });
        console.log("lang filterLang", filterLang);
        if (filterLang.length > 1) {
          const filterLangCountry = filterLang.filter((k) => {
            return (
              k.split("_")[1].toUpperCase() === params.countryCode.toUpperCase()
            );
          });
          console.log("lang filterLangCountry", filterLangCountry);
          //(ps: my_MM my_ZG my_Qaag 特殊处理无法匹配到语言后再匹配国家就使用特殊参数defaultLocale)
          if (!filterLangCountry.length && defaultLocale) {
            // my_Qaag => my_ZG_#Qaag my_ZG => my_ZG my_MM => my_MM 所以优先判断包含Qaag
            if (defaultLocale.indexOf("Qaag".toUpperCase()) > -1) {
              this.langKey = "my_Qaag";
              this.applicationFeedback = feedBack["my_Qaag"];
            } else if (defaultLocale.indexOf("ZG".toUpperCase()) > -1) {
              this.langKey = "my_ZG";
              this.applicationFeedback = feedBack["my_ZG"];
            } else if (defaultLocale.indexOf("MM".toUpperCase()) > -1) {
              this.langKey = "my_MM";
              this.applicationFeedback = feedBack["my_MM"];
            } else {
              const f = filterLang.filter((key) => {
                return key.toUpperCase().indexOf(defaultLocale) > -1;
              });
              this.langKey = f.length ? f[0] : "EN";
              this.applicationFeedback = f.length
                ? feedBack[f[0]]
                : feedBack["EN"];
            }
          } else {
            this.langKey = filterLangCountry.length
              ? filterLangCountry[0]
              : "EN";
            this.applicationFeedback = filterLangCountry.length
              ? feedBack[filterLangCountry[0]]
              : feedBack.EN;
          }
        } else {
          this.langKey = filterLang.length ? filterLang[0] : "EN";
          this.applicationFeedback = filterLang.length
            ? feedBack[filterLang[0]]
            : feedBack.EN;
        }
      } else {
        this.langKey = "EN";
        this.applicationFeedback = feedBack.EN;
        console.log("no lang");
      }
      this.isDark = +params.isDark || 0;
    },
    submit() {
      const params = parseQueryString(location.href) || {};
      const countryCode = params.countryCode || "";
      const packageName = params.packageName || "";
      if (
        +this.checked < 0 ||
        (+this.checked === this.otherIndex && !this.opinion)
      ) {
        return;
      }
      const obj = {
        category: feedBack.EN.feedBackCates[this.checked].txt,
        // category: this.applicationFeedback.feedBackCates[this.checked].txt,
        opinion: +this.checked === this.otherIndex ? this.opinion : "",
        countryCode,
        itemValue: packageName,
      };
      const str = JSON.stringify(obj);
      gtag(`submit_feedback_${str}`);
      gtagApp({
        ...obj,
        eventId: 104460000457,
        eventName: "ps_h5_submit_feedback",
        // event: "submit_feedback_plamstore-h5",
      });
      Toast({
        message: this.applicationFeedback.submitTip,
        position: "top",
      });
      setTimeout(() => {
        this.back();
      }, 2000);
    },
    back() {
      if (window.android && window.android.finishWebActivity) {
        window.android.finishWebActivity();
      }
    },
    radioGroupChange(val) {
      this.checked = val;
      console.log(val);
      if (val === this.otherIndex) {
        this.$refs.otherOpinionRef.focus();
      }
    },
  },
};
</script>
<style lang="scss" scoped>
@media (max-width: 767px) {
  /* 移动端样式 */

  .ignore--qqq {
    height: 50px;
    width: 50px;
    background: #000;
  }
  .black_bg {
    background: #000000 !important;
    background-color: #000000 !important;
  }
  .white_bg {
    background: #fff !important;
    background-color: #fff !important;
  }
  .application {
    width: 100%;
    height: 100vh;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;

    .application_contain {
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      align-items: flex-start;
      width: 100%;
      overflow-y: scroll;
      .application-nav {
        height: 15.55556vw;
        width: 100%;
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: center;
        img {
          width: 6.66667vw;
          height: 6.66667vw;
          margin-left: 4.44444vw;
        }
      }
      .contain-title {
        padding-left: 6.66667vw;
        font-family: Roboto-Regular;
        font-size: 3.88889vw;
        color: rgba(0, 0, 0, 0.4);
        letter-spacing: 0;
        font-weight: 400;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: center;
      }
      .contain-title_black {
        padding-left: 6.66667vw;
        font-family: Roboto-Regular;
        font-size: 3.88889vw;
        color: rgba(222, 222, 222, 0.53);
        letter-spacing: 0;
        font-weight: 400;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: center;
      }
      .contain-radioGroup {
        width: calc(100% - 13.33333vw);
        padding: 0 6.66667vw;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
      }

      .contain-field {
        width: 100%;
        height: 16.66667vw;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        font-family: Roboto-Regular;
        font-size: 4.44444vw;
        letter-spacing: 0;
        line-height: 6.01944vw;
        font-weight: 400;
        img {
          width: 6.66667vw;
          height: 6.66667vw;
        }
      }
      .contain-field_option {
        width: 100%;
        .van-cell {
          padding: 3.33333vw 6.66667vw !important;
        }
      }
    }

    .application_footer {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 100%;
      height: 50vw;
      .application_btn {
        height: 10vw;
        width: 60vw;
        background: #40c0f2;
        border-radius: 5.83333vw;
      }
      .application_btn .van-button__text {
        font-family: Roboto-Medium;
        font-size: 3.88889vw;
        color: #ffffff;
        letter-spacing: 0;
        text-align: center;
        line-height: 5.27778vw;
        font-weight: 500;
      }
    }
  }
}
/* 在全局 CSS 中 */
@media (min-width: 768px) {
  /* 桌面端（≥1200px） */

  .black_bg {
    background: #000000 !important;
    background-color: #000000 !important;
  }
  .white_bg {
    background: #fff !important;
    background-color: #fff !important;
  }
  .application {
    width: calc(100% - 3.83333vw);
    height: calc(100% - 8.33333vw);
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    padding: 4.16667vw 1.91667vw 4.16667vw 1.91667vw;

    .application_contain {
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      align-items: flex-start;
      width: 100%;
      overflow-y: scroll;
      .application-nav {
        height: 7.58833vw;
        width: 100%;
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: center;
        img {
          width: 3.26667vw;
          height: 3.26667vw;
        }
      }
      .contain-title {
        margin-top: 1.57833vw;
        font-family: Roboto-Regular;
        font-size: 2.5vw;
        color: #999999;
        letter-spacing: 0;
        font-weight: 400;
        height: 2.91667vw;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: center;
      }
      .contain-title_black {
        margin-top: 1.57833vw;
        font-family: Roboto-Regular;
        font-size: 2.5vw;
        color: rgba(222, 222, 222, 0.53);
        letter-spacing: 0;
        font-weight: 400;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: center;
      }
      .contain-radioGroup {
        width: 100%;
        margin-top: 0.66667vw;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
      }
      .contain-field {
        width: 100%;
        height: 3vw;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        font-family: Roboto-Regular;
        font-size: 2.16667vw;
        letter-spacing: 0;
        line-height: 3vw;
        font-weight: 400;
        margin-top: 4.33333vw;
        img {
          width: 2.25vw;
          height: 2.25vw;
        }
      }
      .contain-field_option {
        width: 100%;
        margin-top: 4.33333vw;
        .van-cell {
          padding: 0px 0px !important;
        }
      }
    }

    .application_footer {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 100%;
      height: 4.87833vw;
      .application_btn {
        height: 4.87833vw;
        width: 46.07083vw;
        background: #007aff;
        border-radius: 8.53667vw;
      }
      .application_btn .van-button__text {
        font-family: Roboto-Medium;
        font-size: 1.89667vw;
        color: #ffffff;
        letter-spacing: 0;
        text-align: center;
        line-height: 2.57417vw;
        font-weight: 500;
      }
    }
  }
}
</style>
<style lang="scss">
@media (max-width: 767px) {
  .custom-toast.van-toast {
    background: var(--custom-bg) !important;
  }
  .van-toast {
    font-size: 4.44444vw !important;
    min-width: 26%;
    max-width: 80%;
  }
  .van-toast--html,
  .van-toast--text {
    min-height: unset !important;
    padding: 2.66667vw 4vw;
    line-height: 1.4;
    white-space: normal;
    word-break: break-word;
    overflow-wrap: break-word;
  }
  .contain-field_white {
    color: #000000 !important;
    .van-radio__label {
      color: #000000 !important;
    }
    .van-field__control {
      color: #000000 !important;
      font-size: 4.44444vw;
    }
  }
  .contain-field_black {
    color: #ffffff !important;
    .van-radio__label {
      color: #ffffff !important;
    }
    .van-field__control {
      color: #ffffff !important;
      font-size: 4.44444vw;
    }
  }
}
@media (min-width: 768px) {
  .custom-toast.van-toast {
    background: var(--custom-bg) !important;
  }
  .van-toast {
    font-size: 2.16667vw !important;
    min-width: 26%;
    max-width: 60%;
  }
  .van-toast--html,
  .van-toast--text {
    min-height: unset !important;
    padding: 1.2vw 1.6vw;
    line-height: 1.4;
    white-space: normal;
    word-break: break-word;
    overflow-wrap: break-word;
  }
  .contain-field_white {
    color: #000000 !important;
    .van-radio__label {
      color: #000000 !important;
    }
    .van-field__control {
      color: #000000 !important;
      font-size: 2.16667vw;
    }
  }
  .contain-field_black {
    color: #ffffff !important;
    .van-radio__label {
      color: #ffffff !important;
    }
    .van-field__control {
      color: #ffffff !important;
      font-size: 2.16667vw;
    }
  }
}
</style>
